//import SelectDateController from "../ReuseComps/SelectDateController";
import DateController from "../ReuseComps/DateController";

export default function SelectDateThyroid() {

  return (

    <DateController
        category = "thyroid_health"  
       />  

  );
}
